import { isValidDate } from "./utils";

export const RSC_SIZE = {
    "FULL": 34,
    "DISCIPLINE": 3,
    "SEX": 1,
    "EVENT": 18,
    "PHASE": 4,
    "UNIT": 8,
};


var SpecialCharRSC = "-"
export const RSC_EMPTY = {
    "DISCIPLINE": SpecialCharRSC.repeat(RSC_SIZE.DISCIPLINE),
    "SEX": SpecialCharRSC.repeat(RSC_SIZE.SEX),
    "EVENT": SpecialCharRSC.repeat(RSC_SIZE.EVENT),
    "PHASE": SpecialCharRSC.repeat(RSC_SIZE.PHASE),
    "UNIT": SpecialCharRSC.repeat(RSC_SIZE.UNIT),
    "FULL": SpecialCharRSC.repeat(RSC_SIZE.FULL),
};

/**
 * Return String RSC Discipline composed DISCIPLINE
 * 
 * Example: ATH-------------------
 *
 * @_rsc : RSC Code  to extract long discipline 
 */
export function getLongDisciplineRSC(_rsc) {
    return (_rsc?.slice(0, RSC_SIZE.DISCIPLINE) + RSC_EMPTY.FULL).slice(0, RSC_SIZE.FULL);
}

/**
 * Return String RSC Event composed DISCIPLINE+SEX+EVENT
 * 
 * Example: ATHM200M--------------
 *
 * @_rsc : RSC Code  to extract long Event 
 */
export function getLongEventRSC(_rsc) {
    var ret = RSC_EMPTY.PHASE
    var init = 0//RSC_SIZE.DISCIPLINE + RSC_SIZE.SEX;
    var end = RSC_SIZE.DISCIPLINE + RSC_SIZE.SEX + RSC_SIZE.EVENT;
    if ((_rsc !== undefined) && (_rsc.length >= end)) {
        ret = _rsc.substring(init, end) + RSC_EMPTY.PHASE + RSC_EMPTY.UNIT;
    }
    return ret;
}

/**
 * Return String RSC Phase composed DISCIPLINE+SEX+EVENT+PHASE
 * 
 * Example: ATHM200M--------------QUAL
 *
 * @_rsc : RSC Code  to extract long Event 
 */
export function getLongPhaseRSC(_rsc) {
    var ret = RSC_EMPTY.EVENT

    var init = 0;
    var end = RSC_SIZE.DISCIPLINE + RSC_SIZE.SEX + RSC_SIZE.EVENT + RSC_SIZE.PHASE;
    if ((_rsc !== undefined) && (_rsc.length >= end)) {
        ret = _rsc.substring(init, end) + RSC_EMPTY.UNIT;
    }
    return ret;
}


/**
 * @description
 * Takes complte rsc and returns a event rsc format until event.
 * @param rsc An array of type string.
 * @returns rsc event.
 */
export function getEventRSC(_rsc) {
    var ret = RSC_EMPTY.PHASE
    var init = 0;
    var end = RSC_SIZE.DISCIPLINE + RSC_SIZE.SEX + RSC_SIZE.EVENT;
    if ((_rsc !== undefined) && (_rsc.length >= end)) {
        ret = _rsc.substring(init, end);
    }
    return ret;
}


/**
 * @description
 * Takes complte rsc and returns a phase rsc format until phase.
 * @param rsc An array of type string.
 * @returns rsc phase.
 */
export function getPhaseRSC(_rsc) {
    var ret = RSC_EMPTY.EVENT
    var init = 0;
    var end = RSC_SIZE.DISCIPLINE + RSC_SIZE.SEX + RSC_SIZE.EVENT + RSC_SIZE.PHASE;
    if ((_rsc !== undefined) && (_rsc.length >= end)) {
        ret = _rsc.substring(init, end);
    }
    return ret;
}

export function getUnitRSC(_rsc) {
    var ret = RSC_EMPTY.UNIT
    var init = 0;
    var end = RSC_SIZE.DISCIPLINE + RSC_SIZE.SEX + RSC_SIZE.EVENT + RSC_SIZE.PHASE + RSC_SIZE.UNIT;
    if ((_rsc !== undefined) && (_rsc.length >= end)) {
        ret = _rsc.substring(init, end);
    }
    return ret;
}

export function getDisciplineRSC(_rsc) {
    var ret = RSC_EMPTY.DISCIPLINE
    var init = 0;
    var end = RSC_SIZE.DISCIPLINE;
    if ((_rsc !== undefined) && (_rsc.length >= end)) {
        ret = _rsc.substring(init, end);
    }
    return ret;
}

export function getLevelRSC(_rsc) {

    switch (true) {

        case RSC_EMPTY.UNIT !== getUnit(_rsc):
            return 'UNIT'
        case RSC_EMPTY.PHASE !== getPhase(_rsc):
            return 'PHASE'
        case RSC_EMPTY.EVENT !== getEvent(_rsc):
            return 'EVENT'
        case RSC_EMPTY.SEX !== getSex(_rsc):
            return 'SEX'
        case RSC_EMPTY.DISCIPLINE !== getDiscipline(_rsc):
            return 'DISCIPLINE'
        default:
            return '-';
    }
}


export function getLevelRSCPdf(_rsc, _type, _subcode) {

    if (_type === 'C67') {
        return 'COMMUNI'
    }

    if (isValidDate(_subcode)) {
        return 'DATE'
    }

    switch (true) {
        case RSC_EMPTY.UNIT !== getUnit(_rsc):
            return 'UNIT'
        case RSC_EMPTY.PHASE !== getPhase(_rsc):
            return 'PHASE'
        case RSC_EMPTY.EVENT !== getEvent(_rsc):
            return 'EVENT'
        case RSC_EMPTY.SEX !== getSex(_rsc):
            return 'SEX'
        case RSC_EMPTY.DISCIPLINE !== getDiscipline(_rsc):
            return 'DISCIPLINE'
        default:
            return '-';
    }
}


/**
 * @description
 * Takes a rsc and returns discipline part from rsc.
 * @param rsc A complete rsc.
 * @returns discipline part of rsc.
 */
export function getDiscipline(_rsc) {
    var ret = RSC_EMPTY.DISCIPLINE
    var init = 0;
    var end = RSC_SIZE.DISCIPLINE;
    if ((_rsc !== undefined) && (_rsc.length >= end)) {
        ret = _rsc.substring(init, end);
    }
    return ret;
}
export function getSex(_rsc) {
    var ret = RSC_EMPTY.SEX
    var init = RSC_SIZE.DISCIPLINE;
    var end = RSC_SIZE.DISCIPLINE + RSC_SIZE.SEX;
    if ((_rsc !== undefined) && (_rsc.length >= end)) {
        ret = _rsc.substring(init, end);
    }
    return ret;
}

/**
 * @description
 * Takes a rsc and returns event part.
 * @param rsc A complete rsc.
 * @returns event part of rsc.
 */
export function getEvent(_rsc) {
    var ret = RSC_EMPTY.EVENT
    var init = RSC_SIZE.DISCIPLINE + RSC_SIZE.SEX;
    var end = RSC_SIZE.DISCIPLINE + RSC_SIZE.SEX + RSC_SIZE.EVENT;
    if ((_rsc !== undefined) && (_rsc.length >= end)) {
        ret = _rsc.substring(init, end);
    }
    return ret;
}

export function getPhase(_rsc) {
    var ret = RSC_EMPTY.PHASE
    var init = RSC_SIZE.DISCIPLINE + RSC_SIZE.SEX + RSC_SIZE.EVENT;
    var end = RSC_SIZE.DISCIPLINE + RSC_SIZE.SEX + RSC_SIZE.EVENT + RSC_SIZE.PHASE;
    if ((_rsc !== undefined) && (_rsc.length >= end)) {
        ret = _rsc.substring(init, end);
    }
    return ret;
}

export function getUnit(_rsc) {
    var ret = RSC_EMPTY.UNIT
    var init = RSC_SIZE.DISCIPLINE + RSC_SIZE.SEX + RSC_SIZE.EVENT + RSC_SIZE.PHASE;
    var end = RSC_SIZE.DISCIPLINE + RSC_SIZE.SEX + RSC_SIZE.EVENT + RSC_SIZE.PHASE + RSC_SIZE.UNIT;
    if ((_rsc !== undefined) && (_rsc.length >= end)) {
        ret = _rsc.substring(init, end);
    }
    return ret;
}


export function getRscObject(_rsc) {

    return {
        discipline: getDiscipline(_rsc),
        sex: getSex(_rsc),
        event: getEvent(_rsc),
        phase: getPhase(_rsc),
        unit: getUnit(_rsc),
    }
}

export function completeRsc(_rsc) {
    return ((_rsc ? _rsc : '') + RSC_EMPTY.FULL).slice(0, 34);
}

export function clearEventModifier(_rsc) {
    let event = getEventRSC(_rsc)
    let firstPart = event.slice(0, 12)
    let secondPart = event.slice(-10)
    return firstPart + secondPart.replace(secondPart.slice(-10), '----------')
}